import { AdvisoryLink } from './AdvisoryLink.tsx';
import { AdvisoryInfoIcon } from '../../components/icons/Icons.tsx';
import { SecondaryAdvisory } from '../SecondaryAdvisory.tsx';

export const StateAndLocalAdvisory = () => {
    return (
        <SecondaryAdvisory header="State and Local Warning" advisoryType='advise' icon={AdvisoryInfoIcon} iconColor="medium">
            <p>
                Review state and local drone laws before you launch to ensure compliance with any restrictions and other requirements, such as permits and insurance.
            </p>
            <p>
                <AdvisoryLink
                    text="State and Local Drone Rules"
                    articleKey="STATE_AND_LOCAL_DRONE_RULES"
                />
            </p>
        </SecondaryAdvisory>
    );
};
